import React from "react";
import './BottomFooter.scss';
import privacyOptionImg from '../assets/privacyOptions.svg';

const BottomFooter = () => {
    return (
        <div className="footer">
            <div className="footer-text">Copyright &copy; 2025 Honeywell International Inc.</div>
            <div className="footer-links">
                <a href="https://www.honeywell.com/us/en/terms-and-conditions" target="_blank">
                    <span>Terms & Conditions</span>
                </a>
                <a href="https://www.honeywell.com/us/en/privacy-statement" target="_blank" className="privacyStatement">
                    <span>Privacy Statement</span>
                </a>
                <a href="https://hon-opcenter.my.salesforce-sites.com/PrivacyInformationRequestForm?lang=en" target="_blank" className="privacyChoice">
                    <span>Your Privacy Choices</span>
                    <img src={privacyOptionImg} alt="Privacy Choices" />
                </a>
                <a href="https://www.honeywell.com/us/en/cookie-notice" target="_blank">
                    <span>Cookie Notice</span>
                </a>
                {/* <a href="https://pages1.honeywell.com/GlobalHoneywellUnsubscribe.html" target="_blank">
                    <span>Global Unsubscribe</span>
                </a> */}
            </div>
        </div>
    );
};

export default BottomFooter;